import { Preferences as CapacitorPreferences } from '@capacitor/preferences';

import type { StorageAdapter } from '../types';

/** Async adapter over `@capacitor/preferences`. Never calls Capacitor `clear()`. */
export function createCapacitorPreferencesAdapter(): StorageAdapter {
	return {
		async getItem(key: string): Promise<string | null> {
			const { value } = await CapacitorPreferences.get({ key });

			return value;
		},
		async setItem(key: string, value: string): Promise<void> {
			await CapacitorPreferences.set({ key, value });
		},
		async removeItem(key: string): Promise<void> {
			await CapacitorPreferences.remove({ key });
		},
		async keys(): Promise<string[]> {
			const { keys } = await CapacitorPreferences.keys();

			return keys;
		},
	};
}
